import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { Box, Typography, CircularProgress, Alert } from "@mui/material";
import api from "services/api";
import { IExportHistoryItem, IExportHistoryResponse } from './types';
import { TableView } from './Table';
import { Main } from "./styled";

export function ExportHistory() {
  const { workspaceId } = useParams() as { workspaceId: string };

  const { data, isFetching, isFetched, isError } = useQuery({
    queryKey: ["exportHistory", workspaceId],
    queryFn: () => api.get(`/v2/export/${workspaceId}/history`),
    select: (response) => response.data.data as IExportHistoryItem[],
  });

  return (
    <>
      {!isFetched && isFetching && <div>Loading....</div>}
      {!isFetched && isError && <div>Error...</div>}
      {data && (
        <>
          <h6 style={{"padding":"0","margin":"0","fontSize":"1.25rem","lineHeight":"1.75rem","fontWeight":600}}>Histórico de exportações</h6>
          <TableView data={data} />
        </>
      )}
    </>
  )
}
